import { useSecondsProgress } from '#app/hooks/time.ts'
import { cn } from '#app/utils/misc.tsx'
import { Progress } from './progress.tsx'

type SecondsProgressProps = {
	maxSeconds?: number
	className?: string
	children?: React.ReactNode
}
export function SecondsProgress(props: SecondsProgressProps) {
	let { maxSeconds = 8 } = props
	const [seconds, progress] = useSecondsProgress(maxSeconds)
	return (
		<div
			className={cn(
				'flex w-full flex-col items-end gap-2 px-8',
				props.className,
			)}
		>
			<Progress value={progress} />
			<div className="flex w-full flex-row justify-between gap-2">
				{props.children ?? <span />}
				<span className="text-xs">
					{seconds}s / {maxSeconds}s
				</span>
			</div>
		</div>
	)
}
